<span *ngIf="visible" class="count-badge" [ngClass]="'count-badge--' + type" role="img" [attr.aria-label]="ariaLabel" [attr.title]="ariaLabel">{{ display }}</span>
